import React from 'react'

const BlogPart = ({title, body, className}) => {

  return     <div className={`${className} blogPart`} >
  <h2 className='upperBold'>{title}</h2>
  <div className="body"  dangerouslySetInnerHTML={{__html:body}}>
    
  </div>

</div>
}

export default BlogPart